import { Grid } from "@material-ui/core";
import { useQuoteField } from "Quoting/components/hooks/useHandleQuoteFieldChange";
import React from "react";
import { useSelector } from "react-redux";
import { ReducerState } from "rootReducer";
import { FormRowGrid, GridRowProps } from "Quoting/components/shared/GridRow";
import { QuoteFormElement } from "Quoting/components/shared/QuoteFormElement";
import { FormWrapper } from "Quoting/components/shared/QuoteFormWrapper";
import { getGPLUExclusionsAndLimitationsPropertyPaths } from '../PropertyPaths';

export const ExclusionsAndLimitationsBlock  = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUExclusionsAndLimitationsPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: { key: 'row-f4c02eb3-ab57-424b-a2ba-6e4a284a91b4' },
      title: 'EXCLUSIONS',
      items: [
        {
          key: "67be3d21-1188-4f48-92fc-debdc2ac2341",
          element: (
            <QuoteFormElement
              elementType="FormControl"
              label="Suicide"
              id={propertyPaths.isSuicide}
              checked={getQuoteFieldValue<boolean>(propertyPaths.isSuicide)}
              onChange={e => updateQuoteFieldValue(propertyPaths.isSuicide, e.target.checked)}
              controlType="checkbox"
              disabled
            />
          )
        }
      ]
    }
  ];

  return (
    <FormWrapper title="Exclusions And Limitations" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
